import { createContext } from "solid-js";
export const SelectableContext = createContext(null);
export const makeEventKey = (eventKey, href = null) => {
    if (eventKey != null)
        return String(eventKey);
    return href || null;
};
export default SelectableContext;
